import { useNavigate, useParams } from "react-router-dom";

import { ClientDetail } from "@/modules/users/components/clients/clients-details";
import { Wrapper } from "@/components/layout";
import { routes } from "@/routes/constants";
import { useEffect } from "react";

export const ClientDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate(routes.users.path);
    }
  }, [id, navigate]);

  if (!id) {
    return null;
  }

  return (
    <Wrapper title="Client Detail" showCityList={false} className="overflow-y-scroll">
      <div className="flex p-5 pb-2 w-[97%] mx-auto bg-white shadow-xs rounded-lg relative">
        <div className="w-full">
          <ClientDetail clientId={id} />
        </div>
      </div>
    </Wrapper>
  );
};
